import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Dropdown } from '@telus/d2c-core';
import { Observable } from 'rxjs';
import { commonConstants } from '@telus/d2c-core/constants/common.constants';

@Component({
  template: `<ion-item lines="none" *transloco="let t">
    <ion-col size="12">
      <ion-row *ngIf="title">
        <h6 class="muted-text">{{ t(pageType + '.' + title) }}</h6>
      </ion-row>
      <ion-row>
        <ion-col size="10">
          <div *ngIf="editType === 'text' || editType === 'dropdown'">
            <h6 data-testid="cy-value-for-test-short">{{ value }}</h6>
          </div>
          <div *ngIf="editType === 'longtext'">
            <p data-testid="cy-value-for-test-long">{{ value }}</p>
          </div>
          <div *ngIf="editType === 'list'">
            <ul>
              <li *ngFor="let item of value" data-ttttid="{{item" }}>
                {{ item }}
              </li>
            </ul>
          </div>
        </ion-col>
        <ion-col size="2">
          <ion-button
            data-testid="cy-territory-edit"
            (click)="editDetailSection()"
            *ngIf="isEditable && !isUnnasignable"
            color="light"
            icon-only
            clear
          >
            <ion-icon slot="icon-only" name="create-outline"></ion-icon>
          </ion-button>
          <ion-button
            data-testid="cy-territory-unassign"
            (click)="unnasignDetailSection()"
            *ngIf="isUnnasignable"
            color="primary"
            icon-only
            clear
          >
            <ion-icon slot="icon-only" name="close-circle-outline"></ion-icon>
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-col>
  </ion-item>`,
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'overview-details-section',
})
export class OverviewDetailSectionComponent {
  @Input() title: string;
  @Input() value: string | string[];
  @Input() isEditable = true;
  @Input() isUnnasignable = false;
  @Input() propertyName: string;
  @Input() editType: string;
  @Input() pageType: string;
  @Input() dataSource: Observable<Dropdown[]> = null;
  @Output() emitEditSection = new EventEmitter<any>();

  isModalVisible: boolean;

  constructor() {}

  showModal() {
    this.isModalVisible = true;
  }

  hideModal() {
    this.isModalVisible = false;
  }

  editDetailSection() {
    this.emitEditSection.emit({
      value: this.value,
      editType: this.editType,
      title: this.title,
      propertyName: this.propertyName,
      dataSource: this.dataSource,
    });
  }

  unnasignDetailSection() {
    this.emitEditSection.emit({
      value: undefined,
      editType: this.editType,
      title: this.title,
      propertyName: this.propertyName,
      dataSource: this.dataSource,
      action: commonConstants.UNASSIGN_SALES_REP,
    });
  }
}
